import styled from "styled-components";
import { Radio, Space, Form as AntForm, Input as AntInput, Divider as AntDivider } from "antd";
import { CheckboxCircleFill } from "@assets";

export const RootContainer = styled.div`
  padding: 24px 16px;
`;

export const InfoBox = styled(Space).attrs({
  direction: "vertical",
})`
  width: 100%;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img.attrs({
  alt: "icon",
})`
  width: 74px;
  border-radius: 12px;
`;

export const Text = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => props.status ? props.theme.primarySolid : "#ffffff"};
  padding: 8px 0px 8px 8px;
  border-radius: 8px;
  width: 105px;

  @media screen and (max-width: 345px) {
    font-size: 12px;
  }

  @media screen and (max-width: 320px) {
    font-size: 11px;
  }

  @media screen and (max-width: 400px) {
    width: 95px;
  }
  @media screen and (max-width: 355px) {
    width: 85px;
  }
  @media screen and (max-width: 323px) {
    width: 75px;
  }
  @media screen and (max-width: 292px) {
    width: 65px;
  }
`;

export const AccountText = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.theme.dark1};

  @media screen and (max-width: 345px) {
    font-size: 12px;
  }

  @media screen and (max-width: 320px) {
    font-size: 11px;
  }
`;

export const BoldText = styled.div`
  font-size: 13px;
  font-weight: bold;
  color: #71207c;
`;

export const RadioGroup = styled(Radio.Group)`
  margin-bottom: 32px;

  .ant-radio-inner {
    width: 24px;
    height: 24px;

    ::after {
      width: 24px;
      height: 24px;
      margin-block-start: -12px;
      margin-inline-start: -12px;
    }
  }
`;

export const HelperText = styled.div`
  padding-top: 8px;
  font-size: 12px;
  font-weight: normal;
  color: ${props => props.theme.dark1};

  @media screen and (max-width: 320px) {
    font-size: 11px;
  }
`;

export const ButtonWrapper = styled.div`
  text-align: center;

  .ant-btn {
    width: 100%;
  }
`;

export const Box = styled(Space).attrs({
  size: "middle",
})`
  margin-right: -36px;
  align-items: center;

  .anticon {
    font-size: 20px;
    cursor: pointer;
  }
`;

export const Form = styled(AntForm)`
  width: 100%;

  .ant-form-item {
    margin-bottom: 32px;
  }

  .ant-form-item-label {
    padding-left: 10px;
  }

  input {
    border: 1px solid #e1cce0;
    border-radius: 12px;
  }

  input[type="text"],
  input[type="number"] {
    height: 52px;
  }

  input[type="password"] {
    height: 40px;
  }
`;

export const Input = styled(AntInput)`
  -moz-appearance: textfield;
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
`;

export const RadioButton = styled(Radio)`
  .ant-radio {
    opacity: 0;
    position: fixed;
    width: 0;
  }
`;

export const CheckedRadioIcon = styled(CheckboxCircleFill)`
  width: 18px;
  height: 18px;
  padding-right: 3px;
`;

export const Divider = styled(AntDivider)`
  ::before,
  ::after {
    border: 1px solid ${props => props.theme.divider};
    border-color: ${props => props.theme.divider} !important;
  }
`;